let prefix = "cszx";


export const setUserId = (val) => {
	localStorage.setItem(prefix + 'UserId', val)
}

export const getUserId = () => {
	return localStorage.getItem(prefix + "UserId")
}


export const setAuthorityToken = (val) => {
	localStorage.setItem(prefix + 'AuthorityToken', val)
}

export const getAuthorityToken = () => {
	return localStorage.getItem(prefix + "AuthorityToken")
}

export const removeAuthorityToken = () => {
	return localStorage.removeItem(prefix + "AuthorityToken")
}


// WEBPACK FOOTER //
// ./src/utils/storageUtil.js